<template>
  <Card>
    <template #title>
      <slot name="title"></slot>
    </template>
    <template #content>
      <slot></slot>
    </template>
  </Card>
</template>

<script>
import Card from "primevue/card";
export default {
  components: {
    Card,
  },
};
</script>
